export default function FormError({ children }) {
  if (!children) return null
  return (
    <span
      role="alert"
      style={{
        fontSize: 11,
        color: 'var(--olv-red)',
        fontFamily: 'var(--font-mono)',
      }}
    >
      {children}
    </span>
  )
}
